var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.451,
    height: 20.451,
    viewBox: "0 0 20.451 20.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_1_",
    "data-name": "svgexport-6 (1)",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1948",
    "data-name": "Group 1948",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6270",
    "data-name": "Path 6270",
    d: "M182.725,156.579q-.33-.284-.663-.543l-2.584,2.584a4.194,4.194,0,0,1-5.359,5.359l-1.94,1.94a8.812,8.812,0,0,0,3.348.7,9.146,9.146,0,0,0,4.01-1,15.107,15.107,0,0,0,3.188-2.144,19.788,19.788,0,0,0,2.915-3.1.6.6,0,0,0,0-.7,19.794,19.794,0,0,0-2.915-3.1Z",
    transform: "translate(-165.301 -149.803)",
    fill: "#2d62ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6271",
    "data-name": "Path 6271",
    d: "M245.825,248.821a2.993,2.993,0,0,0,2.965-3.419l-3.389,3.389A3,3,0,0,0,245.825,248.821Z",
    transform: "translate(-235.6 -235.6)",
    fill: "#2d62ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6272",
    "data-name": "Path 6272",
    d: "M20.275.177a.6.6,0,0,0-.847,0L14.72,4.884q-.243-.132-.486-.251a9.146,9.146,0,0,0-4.01-1,9.146,9.146,0,0,0-4.01,1A15.106,15.106,0,0,0,3.027,6.777a19.794,19.794,0,0,0-2.915,3.1.6.6,0,0,0,0,.7,19.789,19.789,0,0,0,2.915,3.1,16.881,16.881,0,0,0,1.646,1.254l-4.5,4.5a.6.6,0,1,0,.847.847L20.275,1.024a.6.6,0,0,0,0-.847ZM6.031,10.227a4.192,4.192,0,0,1,6.7-3.358l-.86.86a2.994,2.994,0,0,0-4.149,4.149l-.86.86A4.172,4.172,0,0,1,6.031,10.227Z",
    transform: "translate(0.001 -0.001)",
    fill: "#2d62ed"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye_close.3ca67c7a9d2b0ef78ec0dd851b51b275.svg";
export { ForwardRef as ReactComponent };